import Vuex from 'vuex';
import entryForm from './modules/entry-form';
import entryFormApi from './modules/entry-form-api';
import entryFormButtons from './modules/entry-form-buttons';
import entryFormConfiguration from './modules/entry-form-configuration';
import global from './modules/global';
import judgingFastStart from './modules/judging-fast-start';
import savedView from './modules/saved-view';
import tableField from './modules/table-field';
import topPick from './modules/top-pick';

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    entryForm,
    entryFormApi,
    entryFormButtons,
    entryFormConfiguration,
    global,
    judgingFastStart,
    savedView,
    tableField,
    topPick
  },
  strict: debug
});
